import TransportVehicleInfoGroupDetailModal from './transport-vehicle-info-group-detail-modal.vue'
export default TransportVehicleInfoGroupDetailModal
